<template>
  <div>
    <p class="text-center">
      If you know the name of the organization you would like to join,
      enter it below and we'll send them your request.
    </p>
    <form-wrapper>
      <b-form @submit="onSubmit">
        <b-form-group>
          <label for="name-input">Organization Name</label>
          <input
            v-validate="'required|organizationName'"
            id="name-input"
            :disabled="saving || !client.is_confirmed"
            :class="{ 'is-invalid' : errors.has('name') || apiErrors.name.length}"
            :value="fields.name"
            class="form-control"
            data-vv-as="organization name"
            type="text"
            name="name"
            placeholder="e.g. 'IIP'"
            @input="setName"/>
          <validation-errors :validation-errors="[errors.first('name')]"/>
          <validation-errors v-if="!errors.has('name')" :validation-errors="apiErrors.name"/>
        </b-form-group>

        <b-form-group class="form-buttons">
          <b-button
            :disabled="disabled"
            type="submit"
            variant="primary">
            Confirm
            <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
          </b-button>
        </b-form-group>

        <form-fail :form-errors="apiErrors.other"/>
        <form-success :success="success" class="form-alert">Request Sent!</form-success>
        <b-alert v-if="!client.is_confirmed" show variant="warning" class="text-center">
          You must
          <router-link :to="{name: 'profile'}">confirm your email </router-link>
          before using this form.
        </b-alert>
      </b-form>
    </form-wrapper>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import yourOrganizations from './your-organizations'
import formFail from '../../common/form/form-fail'
import formSuccess from '../../common/form/form-success'
import formWrapper from '../../common/form/form-wrapper'
import validationErrors from '../../common/form/validation-errors'

export default {
  components: {
    formFail,
    formWrapper,
    formSuccess,
    yourOrganizations,
    validationErrors
  },
  data () {
    return {
      header: 'Home'
    }
  },
  computed: {
    ...mapState('client/forms/accessRequest', [
      'apiErrors',
      'success',
      'fields',
      'saving'
    ]),
    ...mapState('client', {
      client: 'data'
    }),
    disabled () {
      return this.errors.any() || !this.fields.name || this.saving
    }
  },
  methods: {
    ...mapActions({
      requestAccess: 'client/requestAccess'
    }),
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.requestAccess()
        }
      })
    },
    setName (e) {
      this.$store.commit('client/forms/accessRequest/setField', {
        field: 'name',
        value: e.target.value
      })
    },
    resetForm () {
      this.errors.clear()
      this.$store.commit('client/forms/accessRequest/resetState')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/home/request-access.vue